export default {
  pageTitle: 'Tentang Kami',
  metaDescription: 'Kenali PT Tokki Engineering and Fabrication (TEF), produsen pressure vessel dan heat exchanger Indonesia yang berdiri sejak 2019, didukung oleh Tokki Ltd Jepang.',
  hero: { title: 'Tentang Kami' },
  companyInfo: {
    dateEstablished: 'Tanggal berdiri',
    capital: 'Modal',
    shareholder: 'Pemegang Saham',
    presidentDirector: 'Direktur Utama',
    totalEmployee: 'Jumlah Karyawan',
    bank: 'Bank',
    emailAddress: 'Alamat Email',
  },
  overview: {
    toggleLabel: 'Gambaran Perusahaan',
    paragraph1:
      'Didirikan pada tahun 2019, PT Tokki Engineering and Fabrication (TEF) merupakan anak perusahaan dari TOKKI LTD., yang dibentuk untuk menyediakan produk fabrikasi berkualitas tinggi dengan harga kompetitif bagi pelanggan di seluruh dunia. Berbasis di Indonesia, TEF berspesialisasi dalam pembuatan <b>bejana tekan las (welded pressure vessel) dan komponen pelat logam</b> untuk berbagai sektor industri, termasuk <b>Minyak & Gas, Petrokimia, Farmasi, Pupuk, Pembangkit Listrik, dan industri Thermal Processing</b>.',
    paragraph2:
      'Dengan komitmen kuat terhadap <strong>keunggulan teknik, keahlian konsultasi, teknik pengelasan canggih, dan penanganan material khusus</strong>, TEF terus berinovasi untuk memenuhi tuntutan industri yang terus berkembang.',
  },
  specialization: {
    toggleLabel: 'Spesialisasi Kami',
    paragraph:
      'TEF sangat berpengalaman dalam fabrikasi produk menggunakan <b>stainless steel, paduan berbasis nikel, titanium, dan material eksotis lainnya.</b> Keahlian kami memastikan daya tahan, presisi, dan kepatuhan terhadap standar internasional.',
  },
  values: {
    toggleLabel: 'Nilai-Nilai Kami',
    item1: {
      title: '1. Layanan Rekayasa & Fabrikasi Satu Atap',
      desc: 'Kami menyediakan solusi yang terintegrasi penuh — mulai dari konsultasi dan desain rekayasa hingga fabrikasi, inspeksi, dan pengiriman — guna memastikan efisiensi, koordinasi, dan kualitas di setiap tahap. TEF juga dapat melakukan pekerjaan rekondisi dan servis, baik di bengkel kami maupun langsung di lokasi pelanggan.',
    },
    item2: {
      title: '2. Keahlian dalam Material Khusus & Berkinerja Tinggi',
      desc: 'Pengalaman kami dengan stainless steel, paduan nikel, titanium, dan material eksotis lainnya memungkinkan kami menghasilkan produk yang tahan lama dan berkinerja tinggi untuk industri proses yang krusial.',
    },
    item3: {
      title: '3. Kualitas Tersertifikasi & Presisi Rekayasa',
      desc: 'Didukung oleh sertifikasi internasional seperti ISO 9001:2015 dan ASME U & R Stamp, proses kami dirancang untuk akurasi, keandalan, dan kepatuhan ketat terhadap standar global.',
    },
    item4: {
      title: '4. Solusi Hemat Biaya dan Berjangka Panjang',
      desc: 'Kami berupaya menjadi penyedia solusi yang meminimalkan biaya perawatan dalam industri proses. Kami berusaha menjadi mitra strategis dengan menawarkan solusi fabrikasi cerdas yang mengurangi kebutuhan perawatan jangka panjang dan meningkatkan stabilitas operasional.',
    },
    item5: {
      title: '5. Kepuasan Pelanggan melalui Pengiriman yang Andal',
      desc: 'Komitmen kami jelas: memberikan produk berkualitas tinggi, tepat waktu, dan dengan harga kompetitif — memastikan setiap pelanggan menerima nilai yang konsisten dan dukungan yang dapat diandalkan.',
    },
  },
  visionMission: {
    heading: 'Visi & Misi',
    vision: {
      title: 'Visi',
      item1:
        'Kami menggabungkan Mastery Meets Innovation untuk menyelesaikan masalah korosi dan permasalahan industri proses lainnya dalam satu tempat.',
      item2: 'Kami bertujuan menjadi fabrikator terpercaya, satu atap, dan terdepan yang memberikan ketenangan pikiran bagi semua pihak.',
    },
    mission: {
      title: 'Misi',
      item1:
        'Kami membangun kepercayaan yang kuat dan menciptakan peluang baru dalam industri proses dengan keahlian, inovasi, semangat menghadapi tantangan, dan kejujuran.',
      item2:
        'Kami memadukan keterampilan tangan dengan teknologi canggih untuk menghadirkan produk dan layanan berkualitas tinggi. Tujuan kami adalah memastikan operasional yang stabil dan ketenangan pikiran bagi pelanggan kami, sambil terus menghadirkan nilai baru bagi bisnis mereka.',
      item3:
        'Kami menerima tantangan dan mendorong perubahan dengan penuh semangat. Dengan begitu, kami membentuk masa depan yang menarik yang menginspirasi industri proses dan mengarah pada pertumbuhan serta inovasi yang berkelanjutan.',
    },
  },
  qualityPolicy: {
    heading: 'Kebijakan Mutu',
    commitmentTitle: 'Komitmen terhadap Peningkatan Berkelanjutan',
    commitmentDesc:
      'Kami berkomitmen untuk terus meningkatkan Sistem Manajemen Mutu guna meningkatkan kepuasan pelanggan <br> dan keunggulan operasional.',
    ourCommitmentsHeading: 'Komitmen Kami:',
    commitment1: '1. Membangun kerja sama tim untuk mencapai sasaran mutu.',
    commitment2: '2. Menerapkan pendekatan yang berorientasi pada pelanggan dengan menghadirkan:',
    deliverList: {
      item1: 'Produk berkualitas tinggi dan andal',
      item2: 'Pengiriman tepat waktu',
      item3: 'Nilai tinggi, harga wajar – direkayasa dengan integritas',
      item4: 'Layanan teknis dan komersial yang responsif',
    },
    accountabilityHeading: 'Akuntabilitas & Kepatuhan:',
    accountabilityList: {
      item1: 'Memastikan kepatuhan terhadap ISO 9001:2015, regulasi, dan ekspektasi pemangku kepentingan.',
      item2: 'Memberdayakan personel Quality Assurance untuk bertindak atas setiap masalah mutu tanpa hambatan.',
      item3: 'Melibatkan setiap karyawan dalam menjaga dan meningkatkan standar mutu.',
    },
    structureHeading: 'Sistem dan Tanggung Jawab yang Terstruktur:',
    structureList: {
      item1: 'Manual Mutu yang komprehensif menjadi panduan praktik mutu kami.',
      item2: 'Seluruh karyawan wajib mematuhi prosedur mutu dan berkontribusi melalui kolaborasi yang efektif.',
      item3: 'Karyawan baru menjalani pelatihan yang terstruktur.',
      item4: 'Manajer Bagian memastikan praktik keselamatan dan mutu diterapkan serta dipahami.',
    },
  },
  parentCompany: {
    heading: 'Perusahaan Induk',
    desc1: 'Perusahaan induk dari PT. Tokki Engineering and Fabrication adalah Tokki Co,. Ltd',
    desc2: 'Detail perusahaan dan bisnis Tokki Co,. Ltd dapat dilihat pada situs web berikut :',
  },
};
